<template>
  <div class="container">
    <div class="row">
      <div class="col-xs-12">
        <ul class="choose-plan">
          <li class="active">
            Para Você
          </li>
          <li class="active">
            Para Sua Empresa
          </li>
        </ul>
      </div>
    </div>

    <div class="row">
      <div class="col-xs-12">
        <h3 class="bold margin-b0 margin-t30">PLANOS</h3>
        <p>Temos dois planos, com certeza um deles é ideal para você, é só escolher:</p>

        <div class="row">
          <div class="col-xs-12">
            <div v-async="loading">
              <div class="row text-center">
                <div class="">
                  <!-- <div class="row"> -->
                    <!-- second col -->
                    <div class="col-md-6 small-padding-right">
                      <div class="second-col-box margin-b10">
                        <div class="height-72 border-radius-top">
                          <h3 class="sub-title plan upper no-margin margin-b10">Pré-pago Manual</h3>
                        </div>
                        <div class="height-100 padding-s10 padding-28">
                          <p class="bold">A quem se destina?</p>
                          <p>Para quem deseja ter controle total sobre os custos e as recargas.</p>
                        </div>
                        <div class="height-112">
                          <p class="bold">Como funciona?</p>
                          <p class="no-margin">Excelente para você que quer ter controle total dos seus gastos e tem tempo para planejar as suas recargas.</p>
                          <br>
                          <!-- <router-link tag="a" to="/servicos-b2c-plano-controle">Saiba Mais</router-link> -->
                        </div>
                        <div class="height-100 padding-14">
                          <p class="bold">Adesão</p>
                          <h4>R$ 39,90</h4>
                          <!-- <h4><strike>R$ 39,90</strike></h4>
                          <h4 class="bold">R$ 31,90*</h4> -->
                        </div>
                        <div class="height-72 padding-t25">
                          <a class="make-link" href="#b2c-recharge" v-smooth-scroll>
                            Veja Nossas Taxas de Recarga
                          </a>
                        </div>
                        <div class="height-82 padding-20">
                          <p class="bold">Formas de Pagamento</p>
                          <ul>
                            <li>Cartão de Crédito</li>
                            <!--<li>Débito Automático</li>-->
                            <!-- <li>Boleto Bancário</li> -->
                          </ul>
                        </div>
                        <div class="row-button border-radius-bottom">
                          <button  @click="choose(21)" class="btn btn-primary" tag="button">
                            Quero este plano!
                          </button>
                        </div>
                      </div>
                    </div>

                    <!-- third col -->
                    <div class="col-md-6 small-padding-left">
                      <div class="third-col-box margin-b10">
                        <div class="height-72 border-radius-top">
                          <h3 class="sub-title plan upper no-margin margin-b10" style="line-height: 0; margin-top: 26px;">Controle</h3>
                          <p class="no-margin">Pré-pago com recarga manual</p>
                        </div>
                        <div class="height-100 padding-s10 padding-28">
                          <p class="bold">A quem se destina?</p>
                          <p>Empresas que querem controle total dos seus gastos e querem planejar as recargas.</p>
                        </div>
                        <div class="height-112 height-72-big padding-18">
                          <p class="bold">Como funciona?</p>
                          <p class="no-margin">
                            O próprio cliente efetua a recarga, escolhendo um dos valores disponíveis ou qualquer valor acima de R$ 2.000,00*.<br/>
                            Sem taxa de mensalidade. Créditos não expiram. Sem caução.<br/>
                            Saldo compartilhado por todos os veículos.<br/>
                            Disponível no app e no site.
                          </p>
                        </div>
                        <div class="height-100 padding-14">
                          <p class="bold">Adesão</p>
                          <h4>R$ 39,90</h4>
                          <!-- <h4><strike>R$ 39,90</strike></h4>
                          <h4 class="bold">R$ 31,90*</h4> -->
                        </div>
                        <div class="height-72 padding-t25">
                          <a class="make-link" href="#b2b-recharge" v-smooth-scroll>
                            Veja Nossas Taxas de Recarga
                          </a>
                        </div>
                        <div class="height-82 padding-20">
                          <p class="bold">Formas de Pagamento</p>
                          <ul>
                            <li>Cartão de Crédito</li>
                            <!--<li>Débito Automático</li>-->
                          </ul>
                        </div>
                        <div class="row-button border-radius-bottom">
                          <button  @click="choose(31)" class="btn btn-primary" tag="button">
                            Quero este plano!
                          </button>
                        </div>
                      </div>
                    </div>
                  <!-- </div> -->
                </div>
              </div>
              <!-- <small>* Valor promocional de R$ 31,90 para pagamentos realizados com Cartão Senff.</small> -->
            </div>
          </div>
        </div>
      </div>
    </div>

    <div id="b2c-recharge">
      <div class="row" id="rechargeB2C">
        <div class="col-xs-12 margin-b10">
          <h3 class="bold upper">Recargas plano pré-pago manual</h3>
          <p>As recargas estão sujeitas a taxas, verifique os valores:</p>
        </div>
      </div>
      <div class="row">
        <div class="col-xs-12">
          <div class="box-recharge">
            <div class="recharge-red">
              <div class="recharge-value-red">R$</div>
              <div class="recharge-label-red">50</div>
              <div class="recharge-tax-label">
                Taxa de Recarga:
                <p>5,00</p>
              </div>
            </div>
          </div>
          <div class="box-recharge">
            <div class="recharge-yellow">
              <div class="recharge-value-yellow">R$</div>
              <div class="recharge-label-yellow">100</div>
              <div class="recharge-tax-label">
                Taxa de Recarga:
                <p>9,40</p>
              </div>
            </div>
          </div>
          <div class="box-recharge">
            <div class="recharge-green">
              <div class="recharge-value-green">R$</div>
              <div class="recharge-label-green">150</div>
              <div class="recharge-tax-label">
                Taxa de Recarga:
                <p>13,20</p>
              </div>
            </div>
          </div>
          <div class="box-recharge">
            <div class="recharge-blue">
              <div class="recharge-value-blue">R$</div>
              <div class="recharge-label-blue">200</div>
              <div class="recharge-tax-label">
                Taxa de Recarga:
                <p>16,40</p>
              </div>
            </div>
          </div>
          <div class="box-recharge-last">
            <div class="recharge-purple">
              <div class="recharge-value-purple">R$</div>
              <div class="recharge-label-purple">250</div>
              <div class="recharge-tax-label">
                Taxa de Recarga:
                <p>19,00</p>
              </div>
            </div>
          </div>
          <div class="box-recharge">
            <div class="recharge-red">
              <div class="recharge-value-red">R$</div>
              <div class="recharge-label-red">300</div>
              <div class="recharge-tax-label">
                Taxa de Recarga:
                <p>21,00</p>
              </div>
            </div>
          </div>
          <div class="box-recharge">
            <div class="recharge-yellow">
              <div class="recharge-value-yellow">R$</div>
              <div class="recharge-label-yellow">350</div>
              <div class="recharge-tax-label">
                Taxa de Recarga:
                <p>22,40</p>
              </div>
            </div>
          </div>
          <div class="box-recharge">
            <div class="recharge-green">
              <div class="recharge-value-green">R$</div>
              <div class="recharge-label-green">400</div>
              <div class="recharge-tax-label">
                Taxa de Recarga:
                <p>22,40</p>
              </div>
            </div>
          </div>
          <div class="box-recharge">
            <div class="recharge-blue">
              <div class="recharge-value-blue">R$</div>
              <div class="recharge-label-blue">450</div>
              <div class="recharge-tax-label">
                Taxa de Recarga:
                <p>21,60</p>
              </div>
            </div>
          </div>
          <div class="box-recharge-last">
            <div class="recharge-purple">
              <div class="recharge-value-purple">R$</div>
              <div class="recharge-label-purple">500</div>
              <div class="recharge-tax-label">
                Taxa de Recarga:
                <p>20,00</p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div id="b2b-recharge">
      <div class="row" id="rechargeB2B">
        <div class="col-xs-12 margin-b10">
          <h3 class="bold upper">Recargas plano controle</h3>
          <p>As recargas estão sujeitas a taxas, verifique os valores:</p>
        </div>
      </div>
      <div class="row">
        <div class="col-xs-12">
          <div class="box-recharge">
            <div class="recharge-red">
              <div class="recharge-value-red">R$</div>
              <div class="recharge-label-red">500</div>
              <div class="recharge-tax-label">
                Taxa de Recarga:
                <p>40,00</p>
              </div>
            </div>
          </div>
          <div class="box-recharge">
            <div class="recharge-yellow">
              <div class="recharge-value-yellow">R$</div>
              <div class="recharge-label-yellow">1000</div>
              <div class="recharge-tax-label">
                Taxa de Recarga:
                <p>70,00</p>
              </div>
            </div>
          </div>
          <div class="box-recharge">
            <div class="recharge-green">
              <div class="recharge-value-green">R$</div>
              <div class="recharge-label-green">1500</div>
              <div class="recharge-tax-label">
                Taxa de Recarga:
                <p>90,00</p>
              </div>
            </div>
          </div>
          <div class="box-recharge">
            <div class="recharge-blue">
              <div class="recharge-value-blue">R$</div>
              <div class="recharge-label-blue">2000</div>
              <div class="recharge-tax-label">
                Taxa de Recarga:
                <p>100,00</p>
              </div>
            </div>
          </div>
          <div class="box-recharge-last">
            <div class="recharge-purple">
              <div class="recharge-value-purple">R$</div>
              <div class="recharge-label-purple">2000+</div>
              <div class="recharge-tax-label">
                Taxa de Recarga:
                <p>5%</p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

  </div>
</template>
<style lang="scss" scoped>
  .bg-services {
    margin: -100px -20px -50px;
  }

  .img-services {
    background-image: url(../../assets/img/img-services.svg);
  }

  .services-mob {
    display: none;
  }

  .btn-large,
  .btn-large:active,
  .btn-large:focus,
  .btn-large:hover {
    padding: 10px 30px;
  }

  .choose-plan {
    margin-top: 20px;
    li {
      position: relative;
      display: inline-block;
      width: 50%;
      color: #613A7D;
      background-color: #F2F2F2;
      padding: 10px 5px;
      text-align: center;
      font-weight: bold;
      font-size: 1.5em;
      cursor: pointer;
      &:first-child {
        float: left;
        -webkit-border-radius: 10px 0 0 10px;
        border-radius: 10px 0 0 10px;
      }
      &:last-child {
        float: right;
        -webkit-border-radius: 0 10px 10px 0;
        border-radius: 0 10px 10px 0;
      }
      &.active {
        color: white;
        background: #613A7D;
        &::after {
          top: 100%;
        	left: 50%;
        	border: solid transparent;
        	content: " ";
        	height: 0;
        	width: 0;
        	position: absolute;
        	pointer-events: none;
        	border-color: rgba(97, 58, 125, 0);
        	border-top-color: #613A7D;
        	border-width: 15px;
        	margin-left: -15px;
        }
      }
    }
    li:hover {
      background-color: #E5E5E5;
    }
    li:hover.active {
      background-color: #613A7D;
      cursor: default;
    }
  }
  .promo-value {
    font-weight: bold;
    margin: 0;
    text-decoration: line-through;
  }
  .promo-free {
    font-size: 1.3em;
  }
  .sub-title.plan {
    color: white;
    font-size: 1.36em;
    margin-top: 16px;
  }
  .recharge-info {
    margin-top: -5px;
  }
  .icon-plans-table {
    color: #000;
    font-size: 3em;
  }
  .top-margin-up {
    margin: -10px 0 0
  }
  .bail-value {
    background-color: #f4d000 !important;
    font-size: 16px;
  }
  .row-button {
    height: 82;
    padding: 21px;
    .btn-primary {
      background: transparent;
      border: 2px solid white;
      padding: 10px 36px;
      box-shadow: none !important;
      -webkit-box-shadow: none !important;
      -moz-box-shadow: none !important;
    }
    .btn-primary:hover {
      background: white;
      color: #503066;
    }
    .btn-primary:active {
      background: rgba(0,0,0,0.2);
      border: 2px solid white;
      color: white;
    }
    .btn-default {
      background: transparent;
      border: 2px solid #613A7D;
      color: #613A7D;
      padding: 10px 36px;
      box-shadow: none !important;
      -webkit-box-shadow: none !important;
      -moz-box-shadow: none !important;
    }
    .btn-default:hover {
      background: #503066;
      border: 2px solid #503066;
      color: white;
    }
    .btn-default:active {
      background: #341045;
    }
  }
  .height-112 {
    height: 140px;
    a {
      color: white;
      text-decoration: underline;
    }
  }
  .height-100 {
    height: 100px;
  }
  .height-82 {
    height: 82px;
  }
  .height-72 {
    height: 72px;
    .form-control {
      font-size: 1.4em;
      width: 200px;
      text-align: center;
      height: 40px;
      margin: 0px -6px;
    }
    a {
      color: white;
      text-decoration: underline;
    }
  }
  .striped-line {
    background-color: #ebebeb;
  }
  .striped-line-purple {
    background-color: #503066;
  }
  p {
    line-height: 15px;
  }
  .btn-sm {
    padding: 5px 30px 7px !important;
  }
  .btn-charge {
    border: 2px solid #b5b5b5;
    padding: 10px;
    color: black;
    margin-top: 5px;
    i {
      font-size: 1.2em;
    }
  }
  .icon-checkmark {
    border: 2px solid white;
    -webkit-border-radius: 50%;
    border-radius: 50%;
    padding: 3px;
    font-size: 0.8em;
    &.align-icon-left-white {
      left: -22px;
    }
  }
  .icon-empty {
    width: 21px;
    height: 21px;
    border: 2px solid #613A7D;
    -webkit-border-radius: 50%;
    border-radius: 50%;
    &.align-icon-left {
      left: -22px;
    }
  }

  .first-col-box {
    width: 140px;
    .height-112,
    .height-82 {
      padding: 15px 10px;
      background-color: #ebebeb;
    }
    .height-72 {
      padding: 5px 10px;
      background-color: #ebebeb;
    }
    & div:nth-child(odd) {
      background-color: rgba(0,0,0,0.05);
    }
  }

  .second-col-box {
    -webkit-box-sizing: border-box;
    -moz-box-sizing: border-box;
    box-sizing: border-box;
    color: white;
    background-color: #6ea500;
    .height-112 {
      /*height: 110px;*/
    }
    .height-72:last-child {
      height: 70px;
    }

  }

  .second-col-box,
  .third-col-box,
  .fourth-col-box,
  .fifith-col-box, {
    -webkit-border-radius: 10px;
    border-radius: 10px;
    .height-112 {
      padding: 15px 10px;
      p {
        /*padding: 0px 50px;*/
        /*color: #613A7D;*/
      }
    }
    .height-72 {
      padding: 10px 30px;
      /*background-color: #ebebeb;*/
    }
    ul {
      width: 144px;
      margin: 0px auto;
      padding-left: 20px;
      li {
        list-style-type: disc;
        text-align: left;
      }
    }
    & div:nth-child(even) {
      background-color: rgba(0,0,0,0.05);
    }
  }
  .third-col-box {
    /*border: 0px solid #000;*/
    background-color: #3472ce;
    color: white;
  }
  .fourth-col-box {
    background-color: #f4d000;
    color: #613A7D;
    .sub-title, a {
      color: #613A7D;
    }
  }
  .fifith-col-box {
    background-color: #57377a;
    color: white;
  }
  .btn-default,
  .btn-default:hover,
  .btn-default:active {
    -webkit-box-shadow: none;
    box-shadow: none;
    border: 0px;
  }
  .padding-14 {
    padding-top: 14px;
    padding-bottom: 14px;
  }
  .padding-18 {
    padding-top: 18px !important;
    padding-bottom: 18px !important;
  }
  .padding-20 {
    padding-top: 20px !important;
    padding-bottom: 20px !important;
  }
  .padding-23 {
    padding-top: 23px !important;
    padding-bottom: 23px !important;
  }
  .padding-28 {
    padding-top: 28px !important;
    padding-bottom: 28px !important;
  }
  .padding-t16 {
    padding-top: 16px !important;
  }
  .padding-t25 {
    padding-top: 25px !important;
  }
  .padding-t28 {
    padding-top: 28px !important;
  }
  .padding-t30 {
    padding-top: 30px !important;
  }
  .padding-t35 {
    padding-top: 35px !important;
  }
  .padding-t45 {
    padding-top: 45px;
  }
  .border-radius-top {
    -webkit-border-radius: 10px 10px 0px 0px;
    border-radius: 10px 10px 0px 0px;
  }
  .border-radius-bottom {
    -webkit-border-radius: 0px 0px 10px 10px;
    border-radius: 0px 0px 10px 10px;
  }

  .plain-box {
    width: 100%;
    /* width: calc(100% - 155px); */
    /* float: left; */
  }

  .mob-title-info {
    font-size: 1.1em;
    font-weight: bold;
    display: none;
  }

  @media screen and (max-width: 991px) {
    .choose-plan {
      display: none;
    }
    .plain-box {
      padding: 0 15px;
      width: 100%;
    }
    .first-col-box {
      display: none;
    }
    .recharge-info {
      margin-bottom: 20px;
    }
    .height-72-big {
      height: auto;
    }
    .height-112,
    .second-col-box .height-112,
    .third-col-box .height-112 {
      height: auto !important;
    }
    .second-col-box {
      & div:nth-child(3) {
        &.padding-28 {
          padding-top: 22px !important;
        }
      }
    }
    .mob-title-info {
      display: block;
    }
  }

  @media screen and (max-width: 500px) {
    p {
      padding: 0 !important;
    }
    .plain-box {
      padding: 0 15px;
      width: 100%;
    }
    .btn-primary {
      padding: 10px 30px;
    }
    .box-recharge,
    .box-recharge-last {
      float: left;
      font-size: 0.8em;
      margin: 0 10px;
      width: calc(50% - 20px);
    }
  }

  .box-recharge {
  float: left;
  height: 150px;
  margin: 0 30px 25px 0;
  width: calc(20.25% - 30px);
}
.box-recharge-last {
  float: left;
  height: 150px;
  margin: 0 0 25px 0;
  width: 19%;
}
.recharge-red {
  -webkit-border-radius: 10px;
  background: #E74213;
  border-radius: 10px;
  color: white;
  width: 100%
}
.recharge-label-red {
  -webkit-border-radius: 10px 10px 0 0;
  background: white;
  border: 2px solid #E74213;
  border-radius: 10px 10px 0 0;
  color: #E74213;
  font-size: 3em;
  font-weight: bold;
  padding: 5px 20px;
  text-align: center;
  width: 100%;
}
.recharge-value-red {
  -webkit-border-radius: 10px 0 10px 0;
  background: #E74213;
  border-radius: 10px 0 10px 0;
  float: left;
  padding: 5px;
}
.recharge-yellow {
  -webkit-border-radius: 10px;
  background: #EDA801;
  border-radius: 10px;
  color: white;
  width: 100%
}
.recharge-label-yellow {
  -webkit-border-radius: 10px 10px 0 0;
  background: white;
  border: 2px solid #EDA801;
  border-radius: 10px 10px 0 0;
  color: #EDA801;
  font-size: 3em;
  font-weight: bold;
  padding: 5px 20px;
  text-align: center;
  width: 100%;
}
.recharge-value-yellow {
  -webkit-border-radius: 10px 0 10px 0;
  background: #EDA801;
  border-radius: 10px 0 10px 0;
  float: left;
  padding: 5px;
}

.recharge-green {
  -webkit-border-radius: 10px;
  background: #569109;
  border-radius: 10px;
  color: white;
  width: 100%
}
.recharge-label-green {
  -webkit-border-radius: 10px 10px 0 0;
  background: white;
  border: 2px solid #569109;
  border-radius: 10px 10px 0 0;
  color: #569109;
  font-size: 3em;
  font-weight: bold;
  padding: 5px 20px;
  text-align: center;
  width: 100%;
}
.recharge-value-green {
  -webkit-border-radius: 10px 0 10px 0;
  background: #569109;
  border-radius: 10px 0 10px 0;
  float: left;
  padding: 5px;
}
.recharge-blue {
  -webkit-border-radius: 10px;
  background: #0074c8;
  border-radius: 10px;
  color: white;
  width: 100%
}
.recharge-label-blue {
  -webkit-border-radius: 10px 10px 0 0;
  background: white;
  border: 2px solid #0074c8;
  border-radius: 10px 10px 0 0;
  color: #0074c8;
  font-size: 3em;
  font-weight: bold;
  padding: 5px 20px;
  text-align: center;
  width: 100%;
}
.recharge-value-blue {
  -webkit-border-radius: 10px 0 10px 0;
  background: #0074c8;
  border-radius: 10px 0 10px 0;
  float: left;
  padding: 5px;
}
.recharge-purple {
  -webkit-border-radius: 10px;
  background: #503066;
  border-radius: 10px;
  color: white;
  width: 100%
}
.recharge-label-purple {
  -webkit-border-radius: 10px 10px 0 0;
  background: white;
  border: 2px solid #503066;
  border-radius: 10px 10px 0 0;
  color: #503066;
  font-size: 3em;
  font-weight: bold;
  padding: 5px 20px;
  text-align: center;
  width: 100%;
}
.recharge-value-purple {
  -webkit-border-radius: 10px 0 10px 0;
  background: #503066;
  border-radius: 10px 0 10px 0;
  float: left;
  padding: 5px;
}
.recharge-tax-label {
  color: white;
  padding: 10px 5px;
  text-align: center;
  width: 100%
}

@media screen and (max-width: 991px) {
  .recharge-info {
    margin-bottom: 20px;
  }
}

@media screen and (max-width: 500px) {
  p {
    padding: 0 !important;
  }
  .box-recharge,
  .box-recharge-last {
    float: left;
    font-size: 0.8em;
    margin: 0 10px;
    width: calc(50% - 20px);
  }
}
@media screen and (min-width: 501px) and (max-width: 991px) {
  .box-recharge,
  .box-recharge-last {
    float: left;
    margin: 0 15px 20px;
    width: calc(33% - 30px);
  }
  .recharge-label-red,
  .recharge-label-yellow,
  .recharge-label-green,
  .recharge-label-blue,
  .recharge-label-purple {
    font-size: 2.5em;
    padding: 5px 25px;
  }
  .recharge-tax-label {
    font-size: 0.95em;
  }
}

  @media screen and (max-width: 479px) {
    .choose-plan li {
      min-height: 80px;
    }
    .choose-plan li:first-child {
     padding: 25px 5px;
    }
  }

  @media screen and (max-width: 699px) {
    .services-mob {
      display: block;
      padding: 50px 20px 50px;
    }
  }

  @media only screen and (max-width: 900px) {
    .bg-services {
      margin: -50px -20px -50px;
    }
  }
</style>

<script>
  import {EventBus} from '../../event-bus'

  export default {
    props: ['type'],
    data() {
      return {
        loading: undefined,
      }
    },


    computed:{

    },

    methods:{
      choose(planId){
        if(this.type=='newContract'){
          EventBus.$emit('chooseNewPlan', planId);
        } else {
          this.$router.push({'name': 'adhesion', 'query':{'planId': planId}});
        }
      },

    }
  }
</script>



// WEBPACK FOOTER //
// services-senff.vue?06ca7f7e